import type { PropsWithChildren } from 'react';
import type React from 'react';

import { Radio } from '@change-corgi/design-system-legacy/components/forms';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { HighlightText } from '../HighlightText';

import { useSelectionCard } from './hooks/useSelectionCard';
import { RadioLabel } from './RadioLabel';
import { containerStyles, contentBoxStyles, radioStyles } from './styles';

export type Props = PropsWithChildren<{
	highlight?: string;
	label: string;
	message: string;
	onSelect: () => void;
	checked: boolean;
	qaSelectorSelection: string;
	qaSelectorLabel: string;
	qaSelectorMessage: string;
}>;

export const Selection: React.FC<Props> = ({
	qaSelectorSelection,
	qaSelectorLabel,
	qaSelectorMessage,
	label,
	message,
	highlight,
	onSelect,
	checked,
	children,
}) => {
	const { data: selectionCardStyles } = useSelectionCard(checked);

	return (
		<Box
			sx={containerStyles({
				checked,
				borderBackgroundColor: selectionCardStyles.borderBackgroundColor,
				borderColor: selectionCardStyles.borderColor,
			})}
			onClick={onSelect}
		>
			{highlight && <HighlightText text={highlight} selected={checked} />}
			<Box
				sx={contentBoxStyles({
					checked,
					highlight,
					backgroundColor: selectionCardStyles.backgroundColor,
				})}
			>
				<Radio
					data-qa={qaSelectorSelection}
					data-testid="selection-radio"
					checked={checked}
					readOnly
					sx={radioStyles}
					label={
						<RadioLabel
							qaSelectorLabel={qaSelectorLabel}
							qaSelectorMessage={qaSelectorMessage}
							label={label}
							message={message}
						>
							{children}
						</RadioLabel>
					}
				/>
			</Box>
		</Box>
	);
};
